import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=461410f0&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"
import style0 from "./Filter.vue?vue&type=style&index=0&id=461410f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461410f0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/Filter.vue
// module id = 2298
// module chunks = 31